import {
  LocationAlertParam,
  LocationAlerts,
  LocationRecentOptionsAnalysisTypeEnum,
  SensorAlertParam,
  SensorAlerts,
  SensorRecentOptionsAnalysisTypeEnum,
} from '../../services/api';
import { VarName } from '../../utils/varNames';

export const defaultAnalysisPeriodDays = 1;
export const defaultHoursLimit = 1;
export const defaultHoursOfDayFilter = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];
export const defaultDaysOfWeekFilter = [0, 1, 2, 3, 4, 5, 6];
export const defaultSensorsLimit = 1;

export type Alert = LocationAlerts | SensorAlerts;
export type AlertParam = LocationAlertParam | SensorAlertParam;
// export type AnalysisType = LocationAnalysisType | SensorAnalysisType;

export enum AlertType {
  email = 'email',
  webhook = 'webhook',
}

export enum ChecklistType {
  sensor = 'sensor',
  location = 'location',
}

export interface MethodForm {
  id: number;
  type: AlertType;
  address: string;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function parseNums(str: string): number[] | undefined {
  if (!str.trim()) return undefined;
  const arr = str
    .split(',')
    .map((s) => parseInt(s.trim(), 10))
    .filter((n) => !Number.isNaN(n));
  return arr.length ? arr : undefined;
}

export function makeDefaultAlertParam(isLocation: boolean): AlertParam {
  return {
    alertId: 1,
    alertMethods: [{ type: 'webhook', params: { url: 'https://' } }],
    analysisOptions: {
      varName: VarName.Unknown,
      threshold: {},
      analysisType: isLocation
        ? LocationRecentOptionsAnalysisTypeEnum.LocationRecent
        : SensorRecentOptionsAnalysisTypeEnum.SensorRecent,
    },
  } as AlertParam;
}
